import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {doc, getDoc, addDoc, setDoc, collection, deleteDoc, Timestamp} from "firebase/firestore";
import {Firestore} from "../../../utils/Firebase";
import * as React from "react";
import {DashboardMenuContainer} from "../Dashboard/DashboardMenu";
import {Button, Container, Grid, MenuItem, TextField} from "@mui/material";
import "../Shelters/sheltersStyle.css";

const helpCategories = [
    {
        value: 'clothing',
        label: 'Oblečenie',
    },
    {
        value: 'food',
        label: 'Jedlo',
    },
    {
        value: 'cosmetic',
        label: 'Drogéria',
    },
    {
        value: 'other',
        label: 'Ostatné',
    },
];


const MaterialHelp = () => {
    const [helpData, setHelpData] = useState({
        category: "",
        logo: "",
        provider: "",
        provides: "",
        where: "",
        when: new Timestamp(0, 0),
    });

    const navigate = useNavigate();
    const {id} = useParams();

    useEffect(() => {
        getDoc(doc(Firestore, "materialHelp", id))
            .then(d => {
                if (d.exists()) {
                    const data = d.data();
                    setHelpData({
                        ...data,
                        when: new Timestamp(data.when.seconds, data.when.nanoseconds)
                    });
                }
            })
            .catch(e => {
                console.error(e);
            });

    }, [id]);

    const handleInputChange = (event) => {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if (target.type === "number") {
            value = parseFloat(value);
        }
        const name = target.name;
        console.log(helpData);
        setHelpData({
            ...helpData,
            [name]: value
        });
    }

    const sendFormData = (e) => {
        e.preventDefault();
        if (id !== "new") {
            setDoc(doc(Firestore, "materialHelp", id), helpData)
                .then(doc => {
                    navigate('/material-helps');
                });
        }
        else {
            addDoc(collection(Firestore, "materialHelp"), helpData)
                .then(doc => {
                    navigate('/material-helps');
                });
        }
    }

    const deleteThisDoc = () => {
        deleteDoc(doc(Firestore, "materialHelp", id))
            .then(doc => {
                navigate('/material-helps');
            });
    }

    return (
        DashboardMenuContainer(
            <Container maxWidth="md">
                <h1>Úprava materiálnej pomoci</h1>
                <form onSubmit={sendFormData}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="provides"
                                name="provides"
                                label="Názov poskytnutej pomoci"
                                value={helpData.provides}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="category"
                                name="category"
                                select
                                label="Kategória pomoci"
                                value={helpData.category}map
                                onChange={handleInputChange}
                            >
                                {helpCategories.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="when"
                                name="when"
                                label="Kedy"
                                type="date"
                                value={helpData.when.toDate().toISOString().replace(/T.*/,'')}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const seconds = new Date(value).getTime()/1000;
                                    setHelpData({
                                        ...helpData,
                                        when: new Timestamp(seconds, 0)
                                    });
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="where"
                                name="where"
                                label="Kde"
                                value={helpData.where}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="provider"
                                name="provider"
                                label="Poskytovateľ pomoci"
                                value={helpData.provider}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="logo"
                                name="logo"
                                label="Logo poskytovateľa"
                                value={helpData.logo}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button type="submit" variant="contained">{id === "new" ? "Pridať" : "Upraviť"}</Button>
                        </Grid>
                        {
                            id !== "new" &&
                            <Grid item xs={12}>
                                <Button variant="contained" color='error' onClick={deleteThisDoc}>Vymazať</Button>
                            </Grid>
                        }
                    </Grid>
                </form>
            </Container>
        )
    );
}

export default MaterialHelp;
